import { ChangeDetectionStrategy, Component, OnInit, input, linkedSignal } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Observable, interval, map, startWith, tap } from 'rxjs';
import { formatDate } from '@kaseya-utils';

@Component({
  selector: 'itc-countdown',
  templateUrl: 'countdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class CountdownComponent implements OnInit {
  private readonly counterIntervalMs = 1000;

  readonly seconds = input.required<number>();
  readonly currentSeconds = linkedSignal(() => this.seconds());
  readonly formatDate = formatDate;

  counter$?: Observable<Date>;

  ngOnInit(): void {
    this.currentSeconds.update(seconds => seconds - 1);
    this.counter$ = interval(this.counterIntervalMs).pipe(
      startWith(new Date(0, 0, 0, 0, 0, this.currentSeconds())),
      tap(() => {
        this.currentSeconds.update(seconds => seconds - 1);
      }),
      map(result => (typeof result === 'number' ? new Date(0, 0, 0, 0, 0, this.currentSeconds()) : result))
    );
  }
}
